<template>
  <div class="ZoomingFunctionDiv">
    <div class="miniTitle">
      <div style="color: #bce874;">Velikost textu</div>
      <!-- <div class="languageArrow">
            <img v-if="language3Show" src="@/assets/images/blueboxArrowOpen.jpg" border="0" alt="">
            <img v-if="!language3Show" src="@/assets/images/blueboxArrowClosed.jpg" border="0" alt="">
        </div> -->
    </div>
    <div class="textSize d-flex justify-content-between align-items-center">
      <div style="font-size: 11px">Zvětšit</div>
      <div class="d-flex justify-content-end align-items-center">
        <div class="textDecrease d-flex justify-content-end align-items-center">
          <img
            src="@/assets/images/textEnlargeActive.gif"
            border="0"
            :style="{ cursor: customFontSize < 32 ? 'pointer' : 'not-allowed' }"
            width="13"
            height="13"
            alt="Enlarge Text"
            class="cursor_pointer"
            @click="zoomInFonts"
          />
        </div>
      </div>
    </div>
    <div class="textSize d-flex justify-content-between align-items-center">
      <div style="font-size: 11px">Zmenšit</div>
      <div class="d-flex justify-content-end align-items-center">
        <div class="textIncrease d-flex justify-content-end align-items-center">
          <img
            src="@/assets/images/textShrinkActive.gif"
            border="0"
            :style="{ cursor: customFontSize > 16 ? 'pointer' : 'not-allowed' }"
            width="13"
            height="13"
            alt="Shrink Text"
            class="cursor_pointer"
            @click="zoomOutFonts"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "@/apiList";

export default {
  name: "ZoomingFunction",
  data() {
    return {
      customFontSize: this.$store.getters.clientSideCustomFontSize || 16,
      zoomingFuncToggle: true,
    };
  },
  methods: {
    zoomInFonts() {
      if (this.customFontSize < 32) {
        this.customFontSize = this.customFontSize + 2;
        this.$store.dispatch("customizeFontsSize", this.customFontSize);
      }
    },
    zoomOutFonts() {
      if (this.customFontSize > 16) {
        this.customFontSize = this.customFontSize - 2;
        this.$store.dispatch("customizeFontsSize", this.customFontSize);
      }
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
$global_color: #4c709b;
$global_color_lit: #4c709bcc;

.ZoomingFunctionDiv {
  // background-color: #ccffb3;
  background-color: $global_color;
  padding: 1px 5px 5px 5px;
  // border: 1px #99ff66 solid;
  border: 1px $global_color solid;
  // color: #003399;
  color: #eee;
  width: 100%;
  border-radius: 5px;
  font-weight: 600;

  .textSize {
    line-height: 20px !important;

    .textDecrease,
    .textIncrease {
      width: 17px;
      float: right;
      cursor: pointer;

      img {
        width: 18px;
        height: 18px;
        border-radius: 100px;
        border: 2px solid #fff;
      }
    }
  }
}
</style>